import React, { useState, useEffect } from "react";
import { Modal, Table, Row, Col, Tooltip } from "antd";
import MediaFetcher from "../library/MediaFetcher";
import moment from "moment";
import {
  TableColumnTitle,
  PrimaryTableRowText,
  TooltipText,
} from "../../../shared/globalStyling/styledText";
import { useAssignAdUnits } from "../hooks/assignAdUnits";

const EditDisplayAdUnitsModal = ({
  visible,
  onClose,
  orgMedias,
  adGroupId,
  initialSelected,
  onSubmit,
  title = "Edit Ad Units",
}) => {
  const [selectedIds, setSelectedIds] = useState(initialSelected || []);
  const { handleAssignAdUnits, assigning } = useAssignAdUnits(onSubmit);

  useEffect(() => {
    setSelectedIds(initialSelected || []);
  }, [initialSelected, visible]);

  const filteredOrgMedias = orgMedias
    ? orgMedias.filter(media => !initialSelected.includes(media.id))
    : [];

  const rowSelection = {
    selectedRowKeys: selectedIds,
    onChange: setSelectedIds,
  };

  const handleOk = async () => {
    await handleAssignAdUnits([adGroupId], selectedIds);
    if (onSubmit) {
      await onSubmit();
    }
    setSelectedIds([]);
    onClose();
  };

  return (
    <Modal
      visible={visible}
      onCancel={onClose}
      onOk={handleOk}
      confirmLoading={assigning}
      title={title}
      width="90%"
    >
      <div style={{ width: "100%", overflowX: "auto" }}>
        <Table
          rowKey="id"
          rowSelection={rowSelection}
          dataSource={filteredOrgMedias}
          columns={[
            {
              title: "",
              dataIndex: "key",
              key: "key",
              width: "100px",
              align: "left",
              padding: 0,
              render: key => (
                <MediaFetcher
                  mediaKey={key}
                  width="100px"
                  height="100px"
                  objectFit="contain"
                />
              ),
            },
            {
              title: <TableColumnTitle text={"AD Unit Name"} />,
              dataIndex: "name",
              key: "name",
              width: "25%",
              align: "left",
              padding: 0,
              sorter: (a, b) => a.name.localeCompare(b.name),
              render: text => (
                <Row
                  type="flex"
                  justify="start"
                  align="middle"
                  style={{
                    width: "100%",
                  }}
                >
                  <Col span={24}>
                    {text.length > 20 ? (
                      <Tooltip title={<TooltipText text={text} />}>
                        <span>
                          <PrimaryTableRowText
                            text={text.slice(0, 46).concat("...")}
                          />
                        </span>
                      </Tooltip>
                    ) : (
                      <PrimaryTableRowText text={text} />
                    )}
                  </Col>
                </Row>
              ),
            },
            {
              title: <TableColumnTitle text={"Aspect"} />,
              dataIndex: "aspect",
              key: "aspect",
              width: "15%",
              align: "left",
              sorter: (a, b) => a.width - b.width || a.height - b.height,
              render: (_, record) => (
                <div>
                  <PrimaryTableRowText
                    text={`${record.width}x${record.height}`}
                  />
                </div>
              ),
            },
            //To edit and insert For Resolution Property
            {
              title: <TableColumnTitle text={"Hi-Res"} />,
              dataIndex: "ResProp",
              key: "ResProp",
              width: "10%",
              align: "left",
              sorter: (a, b) => a.ResProp.localeCompare(b.ResProp),
              //   render: ResProp => <PrimaryTableRowText text={ResProp} />,
            },
            {
              title: <TableColumnTitle text={"File Type"} />,
              dataIndex: "fileType",
              key: "fileType",
              width: "10%",
              align: "left",
              sorter: (a, b) => a.fileType.localeCompare(b.fileType),
              render: fileType => <PrimaryTableRowText text={fileType} />,
            },
            {
              title: <TableColumnTitle text={"Date Uploaded"} />,
              dataIndex: "createdAt",
              key: "createdAt",
              width: "20%",
              align: "left",
              sorter: (a, b) => {
                const dateA = moment(a.createdAt);
                const dateB = moment(b.createdAt);
                return dateA.isBefore(dateB)
                  ? -1
                  : dateA.isAfter(dateB)
                  ? 1
                  : 0;
              },
              render: createdAt => {
                return (
                  <PrimaryTableRowText
                    text={moment(createdAt).format("MM/DD/YYYY hh:mm A")}
                  />
                );
              },
            },
          ]}
        />
      </div>
    </Modal>
  );
};

export default EditDisplayAdUnitsModal;
